import { CONTENT } from "@/content";
import { Reveal } from "../ui/Reveal";

export function Authority() {
  const h = CONTENT.hero;
  return (
    <section className="section dark authority" id="sobre">
      <div className="wrap">
        <div className="auth-grid auth-grid-solo">
          <div className="auth-left">
            <Reveal>
              <span className="eyebrow on-dark">O que é a UdiSchool</span>
            </Reveal>
            <Reveal className="body" delay={1}>
              {h.institutional.map((p, i) => (
                <p key={i} className={i === 0 ? "auth-lead" : ""}>
                  {p}
                </p>
              ))}
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
